module.exports = __webpack_public_path__ + "img/build-jet-wash-cleaning.f80dfbd7.jpg";